export const getEstimatedDeliveryDate = (order) => {
  if (order.expectedDeliveryDate) {
    return new Date(order.expectedDeliveryDate);
  }

  const baseDate = order.actualDeliveryDate 
    ? new Date(order.actualDeliveryDate)
    : order.createdAt 
    ? new Date(order.createdAt)
    : new Date();

  const deliveryDate = new Date(baseDate);
  deliveryDate.setDate(deliveryDate.getDate() + 3);
  deliveryDate.setHours(18, 0, 0, 0);
  
  return deliveryDate;
};

export const formatDeliveryDate = (date) => {
  if (!date) return null;
  
  const dateObj = date instanceof Date ? date : new Date(date);
  if (isNaN(dateObj.getTime())) return null;
  
  return dateObj.toLocaleDateString('en-IN', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
};

